import classNames from 'classnames';

export const GradientGlobeIcon = ({
  className,
  animated = false,
  ...props
}: { animated?: boolean } & JSX.IntrinsicElements['svg']) => {
  return (
    <svg
      width='40'
      height='40'
      viewBox='0 0 40 40'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={classNames({ 'spinning-icon': animated }, className)}
      {...props}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M27.4058 34.4132C30.4088 32.867 32.866 30.4098 34.4122 27.4068C32.9855 28.2326 31.323 28.9357 29.4833 29.4842C28.9347 31.3239 28.2316 32.9865 27.4058 34.4132ZM20.0002 39.8012C30.9354 39.8012 39.8002 30.9364 39.8002 20.0012C39.8002 9.06593 30.9354 0.201172 20.0002 0.201172C9.06496 0.201172 0.200195 9.06593 0.200195 20.0012C0.200195 30.9364 9.06496 39.8012 20.0002 39.8012ZM15.6218 4.39978C17.0145 4.00974 18.483 3.80117 20.0002 3.80117C21.5174 3.80117 22.9859 4.00974 24.3786 4.39978C24.9619 5.07135 25.5262 5.88979 26.0567 6.86239C26.5668 7.79748 27.0258 8.84459 27.4212 9.98533C25.1293 9.47963 22.6244 9.20117 20.0002 9.20117C17.376 9.20117 14.871 9.47963 12.5792 9.98533C12.9746 8.84459 13.4336 7.79748 13.9437 6.86239C14.4742 5.88979 15.0385 5.07135 15.6218 4.39978ZM12.5945 5.58914C9.59157 7.13534 7.13437 9.59255 5.58817 12.5955C7.01486 11.7698 8.67743 11.0666 10.5171 10.5181C11.0656 8.6784 11.7688 7.01583 12.5945 5.58914ZM9.98436 12.5802C8.84361 12.9756 7.7965 13.4346 6.86141 13.9446C5.88882 14.4751 5.07037 15.0395 4.3988 15.6228C4.00877 17.0155 3.8002 18.484 3.8002 20.0012C3.8002 21.5184 4.00877 22.9869 4.3988 24.3796C5.07037 24.9628 5.88882 25.5272 6.86142 26.0577C7.7965 26.5678 8.84361 27.0267 9.98436 27.4222C9.47866 25.1303 9.2002 22.6254 9.2002 20.0012C9.2002 17.377 9.47866 14.872 9.98436 12.5802ZM12.5792 30.017C12.9746 31.1578 13.4336 32.2049 13.9437 33.14C14.4742 34.1126 15.0385 34.931 15.6218 35.6026C17.0145 35.9926 18.483 36.2012 20.0002 36.2012C21.5174 36.2012 22.9859 35.9926 24.3786 35.6026C24.9619 34.931 25.5262 34.1126 26.0567 33.14C26.5668 32.2049 27.0258 31.1578 27.4212 30.017C25.1293 30.5227 22.6244 30.8012 20.0002 30.8012C17.376 30.8012 14.871 30.5227 12.5792 30.017ZM10.5171 29.4842C11.0656 31.3239 11.7688 32.9865 12.5945 34.4132C9.59157 32.867 7.13437 30.4098 5.58817 27.4068C7.01486 28.2326 8.67743 28.9357 10.5171 29.4842ZM28.0217 28.0227C25.6169 28.6446 22.8984 29.0012 20.0002 29.0012C17.102 29.0012 14.3835 28.6446 11.9787 28.0227C11.3567 25.6179 11.0002 22.8993 11.0002 20.0012C11.0002 17.103 11.3567 14.3844 11.9787 11.9797C14.3835 11.3577 17.102 11.0012 20.0002 11.0012C22.8984 11.0012 25.6169 11.3577 28.0217 11.9797C28.6437 14.3844 29.0002 17.103 29.0002 20.0012C29.0002 22.8993 28.6437 25.6179 28.0217 28.0227ZM30.016 27.4222C31.1568 27.0267 32.2039 26.5678 33.139 26.0577C34.1116 25.5272 34.93 24.9628 35.6016 24.3796C35.9916 22.9869 36.2002 21.5184 36.2002 20.0012C36.2002 18.484 35.9916 17.0155 35.6016 15.6228C34.93 15.0395 34.1116 14.4751 33.139 13.9446C32.2039 13.4346 31.1568 12.9756 30.016 12.5802C30.5217 14.872 30.8002 17.377 30.8002 20.0012C30.8002 22.6254 30.5217 25.1303 30.016 27.4222ZM29.4833 10.5181C31.323 11.0666 32.9855 11.7698 34.4122 12.5955C32.866 9.59255 30.4088 7.13534 27.4058 5.58914C28.2316 7.01583 28.9347 8.6784 29.4833 10.5181Z'
        fill='url(#paint0_linear_4958_63973)'
      />
      <path
        opacity='0.5'
        fillRule='evenodd'
        clipRule='evenodd'
        d='M19.1 20.9V38H20.9V20.9H38V19.1H20.9V2H19.1V19.1H2V20.9H19.1Z'
        fill='url(#paint1_linear_4958_63973)'
      />
      <defs>
        <linearGradient
          id='paint0_linear_4958_63973'
          x1='0.200195'
          y1='20.1257'
          x2='39.8002'
          y2='20.1257'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#FF6A00' />
          <stop offset='1' stopColor='#6B11C5' />
        </linearGradient>
        <linearGradient
          id='paint1_linear_4958_63973'
          x1='2'
          y1='20.1132'
          x2='38'
          y2='20.1132'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#FF6A00' />
          <stop offset='1' stopColor='#6B11C5' />
        </linearGradient>
      </defs>
    </svg>
  );
};
